import React from 'react';

// SET DE ÍCONOS APROBADO (regla de fidelidad, 5ta regla viva): el sistema
// lineal Feria de la lámina D14/D17 — retícula 24px, trazo 1.5 UNIFORME,
// remates y uniones redondos, cero relleno, currentColor. Los primeros 10
// glifos son copia literal del sprite de la maqueta aprobada
// (design/fase-a/d17-portal-definitivo.html); el resto está dibujado en la
// misma anatomía para completar las necesidades del portal. El trazo NO es
// configurable: 1.5 es ley del set (se acepta y descarta strokeWidth para
// compatibilidad de llamada).
const GLYPHS = {
  // ── Lámina aprobada (literal) ──
  doc: <><path d="M6 3h9l3 3v15H6z" /><path d="M15 3v3h3M9 11h6M9 15h6" /></>,
  chat: <path d="M4 5h16v11H10l-6 4z" />,
  check: <path d="M4 12.5l5 5L20 6" />,
  pen: <><path d="M4 20l6-2L21 7l-4-4L6 14l-2 6z" /><path d="M14 6l4 4" /></>,
  rocket: <><path d="M5 19c2-6 4-9 9-12l5-2-2 5c-3 5-6 7-12 9z" /><path d="M5 19l3-3" /></>,
  eye: <><path d="M2 12s4-6.5 10-6.5S22 12 22 12s-4 6.5-10 6.5S2 12 2 12z" /><circle cx="12" cy="12" r="2.6" /></>,
  cal: <><rect x="4" y="5" width="16" height="15" rx="2" /><path d="M4 10h16M9 3v4M15 3v4" /></>,
  arrow: <path d="M7 17L17 7M9 7h8v8" />,
  clock: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></>,
  heart: <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10z" />,
  // ── Extensión en la misma anatomía ──
  download: <><path d="M12 4v10" /><path d="M8 10.5l4 4 4-4" /><path d="M5 19h14" /></>,
  lock: <><rect x="6" y="11" width="12" height="9" rx="2" /><path d="M9 11V8a3 3 0 0 1 6 0v3" /></>,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  send: <path d="M4 12l16-7-5 16-3.5-6L4 12z" />,
  paperclip: <path d="M8 12.5l7-7a3 3 0 0 1 4.5 4.5l-8 8a5 5 0 0 1-7-7l7.5-7.5" />,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6L17 7M7 17l-1.4 1.4" /></>,
  moon: <path d="M20 13.5A8 8 0 0 1 10.5 4 8 8 0 1 0 20 13.5z" />,
  logout: <><path d="M14 4H6v16h8" /><path d="M11 12h9M17 8.5L20.5 12 17 15.5" /></>,
  'arrow-left': <path d="M19 12H5M10.5 6.5L5 12l5.5 5.5" />,
  package: <><path d="M4 8l8-4 8 4v8l-8 4-8-4z" /><path d="M4 8l8 4 8-4M12 12v8" /></>,
  smile: <><circle cx="12" cy="12" r="8.5" /><path d="M9 10h.01M15 10h.01M8.5 14.5c1 1.2 2.1 1.8 3.5 1.8s2.5-.6 3.5-1.8" /></>,
  alert: <><circle cx="12" cy="12" r="8.5" /><path d="M12 8v5M12 16.2h.01" /></>,
  // Diana/objetivo: anillo de línea + punto central trazado (misma anatomía que la
  // pupila del `eye`); sirve de marcador de paso ACTUAL en la misma familia de trazo
  // que `check`/`lock`. Cero relleno, trazo 1.5 del set, currentColor.
  target: <><circle cx="12" cy="12" r="8.5" /><circle cx="12" cy="12" r="2.4" /></>,
};

export default function PortalIcon({ name, size = 16, style, strokeWidth: _ignored, ...rest }) {
  const glyph = GLYPHS[name];
  if (!glyph) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      {...rest}
    >
      {glyph}
    </svg>
  );
}
